import { BaseSensorWebController } from '../../base/controller/BaseSensorWebController';
import { AzureADSensorComponent } from '../component/AzureADSensorComponent';
import { AzureADSensorView } from '../view/AzureADSensorView';
import { templateAzureADSensor } from '../view/template';
import { IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { SensorType } from '../../types/sensor-type';

export class AzureADSensorController extends BaseSensorWebController {
  public component: AzureADSensorComponent;
  public view: AzureADSensorView;
  public viewConstructor: typeof AzureADSensorView;

  constructor(component: AzureADSensorComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: AzureADSensorView,
      viewTemplate: templateAzureADSensor,
    });
  }

  public isSensorEnabled(): boolean {
    return true;
  }

  computeEventListeners(): IListenerConfig[] {
    return super.computeEventListeners().concat([
      {
        element: this.view.dom.$applicationID,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$tenantID,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$clientSecret,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$connectionString,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$eventHubName,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$consumerGroup,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$eventHubCheckbox,
        event: 'change',
        callback: this.handleEventHubCheckbox,
      },
    ]);
  }

  private handleEventHubCheckbox() {
    const isChecked = this.view.dom.$eventHubCheckbox.checked;
    this.toggleEventHubFields(isChecked);
    this.view.modifyFieldValidators(isChecked);
  }

  private resetEventHubFields() {
    this.view.dom.$connectionString.resetField();
    this.view.dom.$eventHubName.resetField();
    this.view.dom.$consumerGroup.resetField();
  }

  private toggleEventHubFields(isChecked: boolean): void {
    this.view.dom.$connectionString.disabled = isChecked;
    this.view.dom.$eventHubName.disabled = isChecked;
    this.view.dom.$consumerGroup.disabled = isChecked;

    this.view.dom.$connectionString.required = !isChecked;
    this.view.dom.$eventHubName.required = !isChecked;

    if (isChecked) {
      this.view.dom.$eventHubInfoBox.classList.remove('hidden');
      this.component.setSensorType(SensorType.AZURE_AD_AUDIT);
    } else {
      this.view.dom.$eventHubInfoBox.classList.add('hidden');
      this.component.setSensorType(SensorType.AZURE_AD_EVENT_HUB);
    }
  }

  public resetData(): void {
    super.resetData();
    this.view.dom.$applicationID.resetField();
    this.view.dom.$tenantID.resetField();
    this.view.dom.$clientSecret.resetField();
    this.resetEventHubFields();
    this.view.dom.$eventHubCheckbox.checked = false;
    this.view.dom.$consumerGroup.value = '$Default';
  }

  async getDataForView(): Promise<any> {
    return this.component.getSensors()?.[0];
  }

  public postInit(ev): void {
    const sensorId = ev.detail.inEdit;
    if (sensorId) {
      this.setEditFields();
      this.component.setSensorId(sensorId);
    }
  }

  private setEditFields() {
    const sensor = this.component.getSensors()[0];
    const isChecked = sensor?.type === SensorType.AZURE_AD_AUDIT;
    this.component.setSensorType(sensor?.type);
    this.toggleEventHubFields(isChecked);
    this.view.dom.$eventHubCheckbox.checked = isChecked;
  }
}
